import { render, staticRenderFns } from "./ListEmpresaPage.vue?vue&type=template&id=58792b68"
import script from "./ListEmpresaPage.vue?vue&type=script&lang=js"
export * from "./ListEmpresaPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports